/**
 * Computes a list of tree item IDs that need to be expanded to ensure all selected items are visible.
 * @template T
 * @param {T[]} treeItems - The tree structure to evaluate.
 * @param {string[]} [selectedItemIds] - Optional list of selected item IDs.
 * @returns {string[]} A list of item IDs that should be expanded to reveal the selected items.
 */
export function expandTreeItemsToShowSelectedItems(treeItems, selectedItemIds) {
    if (selectedItemIds && selectedItemIds.length > 0) {
        const expandedItemIds = [];
        collectExpandedTreeItemsToShowSelectedItems(treeItems, expandedItemIds, selectedItemIds);
        return expandedItemIds;
    }
    else {
        return [];
    }
}
/**
 * Recursively traverses a tree and ensures that parent nodes of selected items are included
 * in the list of expanded item IDs, enabling visibility of selected items in collapsed trees.
 * @template T
 * @param {T[]} treeItems - The hierarchical list of tree items.
 * @param {string[]} expandedItemIds - The list to populate with IDs of items to be expanded.
 * @param {string[]} selectedItemIds - The list of currently selected item IDs.
 * @returns {boolean} True if any selected item was found in the current subtree.
 */
function collectExpandedTreeItemsToShowSelectedItems(treeItems, expandedItemIds, selectedItemIds) {
    let expandParent = false;
    for (const item of treeItems) {
        if (item.children) {
            if (collectExpandedTreeItemsToShowSelectedItems(item.children, expandedItemIds, selectedItemIds)) {
                if (!expandedItemIds.includes(item.id)) {
                    expandedItemIds.push(item.id);
                }
                expandParent = true;
            }
        }
        if (selectedItemIds.includes(item.id)) {
            expandParent = true;
        }
    }
    return expandParent;
}
